'use client';

import classNames from '@sindresorhus/class-names';
import {Accordion} from '@ui-kit/src/Accordion';
import {
  FooterSection,
  onFooterLinkClick,
  onFooterSectionClick,
} from '@ui-kit/src/Footer/Footer.types';
import {footerTestId} from '@ui-kit/src/Footer/footerTestId';

import {Link} from '@ui-kit/src/Footer/components/Link';

import styles from './Sections.module.scss';

interface Props {
  sections: FooterSection[];
  isLowLinks?: boolean;
  onLinkClick?: (props: onFooterLinkClick) => void;
  onSectionClick?: (props: onFooterSectionClick) => void;
}

export const Sections = ({
  sections,
  onLinkClick,
  onSectionClick,
  isLowLinks,
}: Props) => {
  return (
    <div className={classNames(styles.sections, isLowLinks && styles.lowLinks)}>
      {sections.map(({elements, title}, index) => (
        <div className={styles.section} key={index}>
          <Accordion
            iconTestId={footerTestId.sectionTitleIcon}
            titleTestId={footerTestId.sectionTitle}
            isMobileOnly
            isOpenedDefault={!index}
            onClick={() => onSectionClick?.({index, title})}
            title={<div className={styles.title}>{title}</div>}
          >
            <ul className={styles.list}>
              {elements.map((link, index) => (
                <li key={index} className={styles.listItem}>
                  <Link link={link} onLinkClick={onLinkClick} index={index} />
                </li>
              ))}
            </ul>
          </Accordion>
        </div>
      ))}
    </div>
  );
};
